export class Vector2D {
  x = 0
  y = 0

  constructor(_x: number, _y: number) {
    this.x = _x
    this.y = _y
  }

  length() {
    return Math.hypot(this.x, this.y)
  }

  normalize() {
    const l = this.length()

    this.x /= l
    this.y /= l

    return this
  }
}

export function zEulerRotation(p: Vector2D, angle: number): Vector2D {
  const c = Math.cos(angle)
  const s = Math.sin(angle)
  // Standard 2D rotation matrix (counter-clockwise)
  return new Vector2D(c * p.x - s * p.y, s * p.x + c * p.y)
}

export function add(a: Vector2D, b: Vector2D) {
  return new Vector2D(a.x + b.x, a.y + b.y)
}

export function subtract(a: Vector2D, b: Vector2D) {
  return new Vector2D(a.x - b.x, a.y - b.y)
}
